<template>
  <div v-cloak>
    <div class="header syTitle acea-row row-center-wrapper">
           {{title}}
    </div>
    <div class="detailView row-center-wrapper syDetail">{{detail}}</div>
    <div class="item acea-row row-between-wrapper" v-for="(item, index) in tradeImageList"
        :key="index">
        <div class="pictrue">
          <img :src="item" class="imageStyle" />
        </div>
    </div>
    <div class="acea-row row-center-wrapper syDetail">价格: ￥{{price}}元 </div>

    <div class="inputView">请按顺序填写购买信息：</div>
    <van-cell-group>
      <van-row type="flex" justify="center" align="center" class="labelText">
        <van-col span="6" type="flex" justify="center" align="center" class="labelText">
          <van-col span="6" type="flex" justify="end" align="end" class="labelText2">
            *
          </van-col>
          <van-col span="18" type="flex" justify="start" align="start" class="labelText">
            手机号
          </van-col>
        </van-col>
        <van-col span="18" type="flex" justify="center" align="center">
          <van-field
            v-model="phone"
            placeholder="请输入手机号"
          />
        </van-col>
      </van-row>

    <van-row type="flex" justify="center" align="center" class="labelText">
        <van-col span="6" type="flex" justify="center" align="center" class="labelText">
          <van-col span="6" type="flex" justify="end" align="end" class="labelText2">
            *
          </van-col>
          <van-col span="18" type="flex" justify="start" align="start" class="labelText">
            学生姓名
          </van-col>
        </van-col>
        <van-col span="18" type="flex" justify="center" align="center">
          <van-field
            v-model="userName"
            placeholder="请输入学生姓名"
          />
        </van-col>
      </van-row>
 
 <van-row type="flex" justify="center" align="center" class="labelText">
        <van-col span="6" type="flex" justify="center" align="center" class="labelText">
          <van-col span="6" type="flex" justify="end" align="end" class="labelText2">
            *
          </van-col>
          <van-col span="18" type="flex" justify="start" align="start" class="labelText">
            学校
          </van-col>
        </van-col>
        <van-col span="18" type="flex" justify="center" align="center">
          <van-field
            readonly
            clickable
            v-model="school"
            :value="school"
            placeholder="请选择学校"
            @click="showPickerSchool = true"
          />
        </van-col>
      </van-row>

<van-row type="flex" justify="center" align="center" class="labelText">
        <van-col span="6" type="flex" justify="center" align="center" class="labelText">
          <van-col span="6" type="flex" justify="end" align="end" class="labelText2">
            *
          </van-col>
          <van-col span="18" type="flex" justify="start" align="start" class="labelText">
            年级
          </van-col>
        </van-col>
        <van-col span="18" type="flex" justify="center" align="center">
          <van-field
            readonly
            clickable
            v-model="grade"
            placeholder="请选择年级"
            :value="grade"
            @click="showPickerClass = true"
          />
        </van-col>
      </van-row>

      <van-row type="flex" justify="center" align="center" class="labelText">
        <van-col span="6" type="flex" justify="center" align="center" class="labelText">
          <van-col span="6" type="flex" justify="end" align="end" class="labelText2">
            *
          </van-col>
          <van-col span="18" type="flex" justify="start" align="start" class="labelText">
            班级
          </van-col>
        </van-col>
        <van-col span="18" type="flex" justify="center" align="center">
             <van-field
              readonly
              clickable
              v-model="classes"
              placeholder="请选择班级"
              :value="classes"
              @click="showPickerSubClass = true"
            />
        </van-col>
      </van-row>
      
   

    <van-popup v-model="showPickerSchool" position="bottom">
      <van-picker
        show-toolbar
        :columns="schoolColumns"
        @cancel="showPickerSchool = false"
        @confirm="onConfirmSchool"
      />
    </van-popup>
    <van-popup v-model="showPickerClass" position="bottom">
      <van-picker
        show-toolbar
        :columns="gradeColumns"
        @cancel="showPickerClass = false"
        @confirm="onConfirmGrade"
      />
    </van-popup>
    <van-popup v-model="showPickerSubClass" position="bottom">
      <van-picker
        show-toolbar
        :columns="classesColumns"
        @cancel="showPickerSubClass = false"
        @confirm="onConfirmClass"
      />
    </van-popup>

      <!-- <van-button type="danger">点击购买</van-button> -->
    </van-cell-group>
    <div class="header btnView acea-row row-center-wrapper" @click="buyProductCon" type="submit">点击购买</div>
  </div>
</template>
<style>
.inputView {
  height: 20px;
  margin: 10px;
  font-size: 16px;
}
.labelText {
  font-size: 14px;
  color: #000000;
  background-color: #fff;
}
.labelText2 {
  font-size: 14px;
  color: red;
  background-color: #fff;
}
.detailView {
  margin: 10px;
  color: #000000;
  font-size: 10px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.btnView {
  height: 40px;
  margin: 20px;
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.syTitle {
  margin-top: 10px;
  /* background-color: #e93323; */
  color: #000000;
  font-size: 20px;
}

.syDetail {
  font-size: 14px;
}
.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.imageStyle {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
<script>


import {
  getOrderInfo,
  getProductDetail,
  getOpenId,
  getSchoolList,
  getGradeList,
  getClassesList
} from "@api/public";


import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
import { log } from 'util';
import { Toast } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { pay , oAuth, wechat} from "@libs/wechat";
import { parseQuery } from "@utils/index";
import cookie from "@utils/store/cookie";

import { Loading } from 'vant';
import { Field } from 'vant';
import { Button, Popup, Picker } from 'vant';
import {  Row, Col  } from 'vant';

import { wechatConfigBuy} from "@libs/wechat";

export default {
  name: "GoodsCon",
  components: {
    [Loading.name]:Loading,
    [Field.name]:Field,
    [Button.name]:Button,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    Toast,
    [Row.name]:Row,
    [Col.name]:Col
  },
  data: function() {
    return {
      paySuccess: 0,
      showPickerSchool: false,
      showPickerClass: false,
      showPickerSubClass: false,

      schoolColumns: [],
      gradeColumns: [],
      classesColumns: [],

      schoolIdList: [],
      gradeIdList: [],
      classesIdList: [],

      checked: true,
      title: "",
      price: "",
      detail: "",
      grade: "",
      gradeId: "",
      classes: "",
      classesId: "",
      phone: "",
      school: "",
      schoolId: "",
      userName: "",
      tradeImageList:[]
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {

    let param = parseQuery();
    this.openId = "";

    this.buyInfo = param.buyInfo;
    if (this.buyInfo  != null) {
      this.productId = this.buyInfo.split("-----")[0];
      this.unionId = this.buyInfo.split("-----")[1];
    }else{
      this.productId = "";
      this.unionId = "";
    }


    
    // this.openId = cookie.get("lishu-openid");
    // this.openId =  "ojHwQv8zV_OfXT5-wA0TZ26YeFmA";

    log("this.unionId "+this.unionId);
    log("this.productId "+this.productId);
    

    const _isWechat = isWeixin();

    if (_isWechat) {
      wechatConfigBuy();
    }

     if (param.code != null) {
          let that = this;
          log('param.code  '+param.code);

          getOpenId(param.code).then((data, res) => {

          if (data.code == 0) {
              console.log("open id--");
              console.log(data.data.openId);

              if (data.data && data.data.openId) {
                console.log("open id 2--");
                that.openId = data.data.openId;
              }else{
                that.$dialog.toast({ mes: "openid 网络异常" });
              }
                
            }else{
              log("code --"+data.code);
              that.$dialog.toast({ mes: data.msg });
            }

          }).catch((result)=>{ 
              console.log('error:',result);
            }
          );
    }


    // Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true
    // });

    this.getProductInfo();

    this.getSchoolListMem();

    this.paySuccess = 0;

    this.interval = null;//计时器
 

    this.start();
    // this.setTimeout(()=>{
                      
                  // }, 2000);

  },
  methods: {
    stop(){
      let that = this;
				clearInterval(that.interval);
				that.interval = null;
      },
    start(){//启动计时器函数
        let that = this;
				if(that.interval!=null){//判断计时器是否为空
					clearInterval(that.interval);
					that.interval=null;
				}
				that.interval = setInterval(that.overs,1500);//启动计时器，调用overs函数，
      },
    overs(){
        let that = this;
        //log("--------time out---------", that.paySuccess);
        if (that.paySuccess == 1){
          stop();
          window.location.href = "http://datum.lishuedu.com/about";
        }
			},
    onConfirmSchool(value) {
      this.school = value;
      this.showPickerSchool = false;
      for (let index = 0; index < this.schoolColumns.length; index++) {
        const element = this.schoolColumns[index];
        if (element == this.school) {
          this.schoolId = this.schoolIdList[index];
          break;
        }
        
      }

      this.getGradeListMem();
    },
    onConfirmGrade(value) {
      this.grade = value;
      this.showPickerClass = false;

       for (let index = 0; index < this.gradeColumns.length; index++) {
        const element = this.gradeColumns[index];
        if (element == this.grade) {
          this.gradeId = this.gradeIdList[index];
          break;
        }
        
      }

      this.getClassesListMem();
    },
    onConfirmClass(value) {
      this.classes = value;
      this.showPickerSubClass = false;

      for (let index = 0; index < this.classesColumns.length; index++) {
        const element = this.classesColumns[index];
        if (element == this.classes) {
          this.classesId = this.classesIdList[index];
          break;
        }
        
      }
    },
    //产品详情接口；
    buyProductCon: function() {
      let that = this;

      const {price, grade, phone, school, userName, classes, classesId, gradeId, schoolId} = that;

      if (grade.length < 1) {
        that.$dialog.error("班级未填写");
        return;
      }
      if (phone.length < 1) {
        that.$dialog.error("手机未填写");
        return;
      }
      if (school.length < 1) {
        that.$dialog.error("学校未选择");
        return;
      }
      if (userName.length < 1) {
        that.$dialog.error("姓名未选择");
        return;
      }
      if (classes.length < 1) {
        that.$dialog.error("班级未选择");
        return;
      }

      function isPoneAvailable(phone) {
            var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
            if (!myreg.test(phone)) {
                return false;
            } else {
                return true;
            }
        }

      if (isPoneAvailable(phone) == false) {
        that.$dialog.toast({ mes: "请输入正确手机号!!" });
        return;
      }

      // that.$dialog.toast({ mes: "open id "+this.openId });
      
      getOrderInfo(that.openId, that.productId, that.unionId, price, userName, phone, classes, classesId, grade, gradeId, school, schoolId)
        .then(res => {
          log(res);
          if (res.code == 0) {
              pay(res.data)
              .finally(() => {
                that.$dialog.toast({ mes: "支付成功" });
                // .then(() => {
                //     that.$router.replace({
                //                           path: "/about"
                //                       });
                // });
                    // that.$router.replace({
                    //     path: "/about"
                    // });

                    // window.location.href = "http://datum.lishuedu.com/about";
                    that.paySuccess = 1;
                
              })
              .catch(function() {
                that.$dialog.toast({ mes: "支付失败" });
              });
          } else{
            log("code --"+res.code);
              that.$dialog.toast({ mes: res.msg });
          }

        
        })
        .catch(res => {
        });
    },
    
    getProductInfo: function() {

       let that = this;
      getProductDetail(that.productId)
        .then((res) => {
          that.$set(that, "tradeImageList", res.data.img);
          that.$set(that, "title", res.data.name);
          that.$set(that, "price", res.data.price);
          that.$set(that, "detail", res.data.desc);
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
    getSchoolListMem: function() {

      let that = this;
      getSchoolList(that.productId)
        .then((res) => {
          log(res.data);
          that.schoolColumns = [];
          that.schoolIdList = [];

          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            log(element.name);
            that.schoolColumns.push(element.name);
            log(element.id);
            that.schoolIdList.push(element.id);
            
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
    getGradeListMem: function() {

      let that = this;
      getGradeList(that.schoolId)
        .then((res) => {
          log(res.data);
          that.gradeColumns = [];
          that.gradeIdList = [];

          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            // log(element.name);
            that.gradeColumns.push(element.name);
            // log(element.id);
            that.gradeIdList.push(element.id);
            
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
    getClassesListMem: function() {

      let that = this;
      getClassesList(that.gradeId)
        .then((res) => {
          log(res.data);
          that.classesColumns = [];
          that.classesIdList = [];
          
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            // log(element.NAME);
            that.classesColumns.push(element.NAME);
            // log(element.id);
            that.classesIdList.push(element.id);
            
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
  }
};
</script>
